export const getJsonHandler = <T>() => (r: Response) =>
  (r.ok
    ? r.json()
    : r.text().then(text => {
        throw Error([r.statusText, text].filter(t => t !== "").join(": "));
      })) as Promise<T>;
